import { remove, removeBulkMile } from '../index';

export const deleteDiscipline = (data) => {
  return remove(`/discipline`, data);
};

export const deleteBulkDiscipline = (data) => {
  return removeBulkMile(`/discipline/bulk`, data);
};
